'use strict';

// Number assertions
function isNumber(value) {
    return typeof value === 'number';
}
function isNotNumber(value) {
    return typeof value !== 'number' || Number.isNaN(value) || !Number.isFinite(value);
}
function isNumeric(value) {
    return value != null && value - parseFloat(value) + 1 >= 0;
}
// Array assertions
function isArray(value) {
    return Array.isArray(value);
}
function isEmptyArray(value) {
    return isArray(value) && value.length === 0;
}
// Function assertions
// eslint-disable-next-line @typescript-eslint/ban-types
function isFunction(value) {
    return typeof value === 'function';
}
// Generic assertions
function isDefined(value) {
    return typeof value !== 'undefined' && value !== undefined;
}
function isUndefined(value) {
    return typeof value === 'undefined' || value === undefined;
}
function isNull(value) {
    return value == null;
}
// String assertions
function isString(value) {
    return Object.prototype.toString.call(value) === '[object String]';
}
const __DEV__ = process.env.NODE_ENV !== 'production';
// @ts-ignore
const __TEST__ = process.env.NODE_ENV === 'test';
// Refs
function isRefObject(val) {
    return 'current' in val;
}

exports.__DEV__ = __DEV__;
exports.__TEST__ = __TEST__;
exports.isArray = isArray;
exports.isDefined = isDefined;
exports.isEmptyArray = isEmptyArray;
exports.isFunction = isFunction;
exports.isNotNumber = isNotNumber;
exports.isNull = isNull;
exports.isNumber = isNumber;
exports.isNumeric = isNumeric;
exports.isRefObject = isRefObject;
exports.isString = isString;
exports.isUndefined = isUndefined;
//# sourceMappingURL=assertion.js.map
